<div class="app-page">

  <div class="filter-bar">
    <mat-form-field appearance="outline" class="filter-input">
      <mat-label>{{ 'SEARCH.FLOW_FILTER_LABEL' | translate }}</mat-label>
      <input matInput [(ngModel)]="filterText" (keyup.enter)="onSearch()" placeholder="{{ 'SEARCH.FLOW_FILTER_PLACEHOLDER' | translate }}" />
      @if (filterText) {
        <button matSuffix mat-icon-button (click)="onClearSearch()" aria-label="Clear">
          <mat-icon>close</mat-icon>
        </button>
      }
      <button matSuffix mat-icon-button (click)="onSearch()" aria-label="Search">
        <mat-icon>search</mat-icon>
      </button>
    </mat-form-field>
    @if (isLoading()==true) {
      <mat-progress-bar mode="indeterminate" style="margin-top: 1px;" ></mat-progress-bar>
    }
  </div>

  @if (this._flowitems!=null && this._flowitems.length==0) {
    <div style="font-family: Roboto; margin: 20px;;">
      NO ITEMS FOUND
    </div>
  }

 

  <div #listTopAnchor class="list-top-anchor"></div>
  <div style="display: flex; flex-flow: row wrap; flex-wrap: wrap; margin: 10px; ">
    @for (item of this._flowitems; track (item.ReportId === '00000000-0000-0000-0000-000000000000' ? (item.PlayerNoteId==='00000000-0000-0000-0000-000000000000' ? item.Game.GameId : item.PlayerNoteId) : item.ReportId); let i = $index) {
      @if (isFirstInBucket(i)) {
        <div class="time-bucket-header">
          <span class="time-bucket-label">{{ getTimeBucketLabel(item) }}</span>
          <mat-divider class="time-bucket-divider"></mat-divider>
        </div>
      }
      @if (item.FlowItemType=='SCREPORT') {
        <app-report-card  [Report]="item" style="margin: 5px;"></app-report-card>
      }
      @if (item.FlowItemType=='PLAYERNOTE') {
        <app-note-card [Note]="item" style="margin: 5px;"></app-note-card>
      }
       @if (item.FlowItemType=='GAMEPLAYERRANKING') {
        <app-game-grades-card [GamePlayerRanking]="item" style="margin: 5px;"></app-game-grades-card>
      }
    }
  </div>

</div>
